var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"text-info",attrs:{"to":_vm.getRoute(),"target":_vm.target}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }